import { connect } from 'react-redux';

import { emailChangeConfirm } from 'Redux/ducks/auth';
import EmailChangeConfirm from 'Components/EmailChangeConfirm/EmailChangeConfirm';

const mapStateToProps = ({
  confirm,
}) => ({
  confirm,
});

export default connect(mapStateToProps, { emailChangeConfirm })(EmailChangeConfirm);
